export const TRIGGER_CALL_TO_ACTION = "TRIGGER_CALL_TO_ACTION";
